export class ClientMonth {
	MonthID: number;
	Month: Date;

	constructor(monthId: number, month: Date) {
		this.MonthID = monthId;
		this.Month = month;
	}
}